/* ============================================================
   pc-app.js — comportements du thème
    1. Révélation au scroll
    2. Menu plein écran + méga-menus
    3. Accordéons
    4. Hero : puces, lecture auto, glissé tactile
    5. Marquees : duplication pour boucle infinie
    6. Tiroir panier (local en aperçu, /cart/*.js en Liquid)
    7. Galerie produit
    8. Carrousel d'avis de la buybox
    9. Sélecteur d'offres + contenances
    9 bis. Bandeau de promesses, compte à rebours, date de livraison
   10. Quantité
   11. Barre d'achat flottante
   12. Barres de notation
   Zéro dépendance.
   ============================================================ */
(function () {
  'use strict';

  var q  = function (s, r) { return (r || document).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var money = function (cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };

  /* ---------- 1. RÉVÉLATION AU SCROLL -------------------- */
  function initReveal() {
    var els = qa('[data-reveal]');
    if (!els.length) return;
    if (!window.IntersectionObserver || REDUCED) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- 2. MENU ------------------------------------ */
  function initMenu() {
    var overlay = q('[data-menu-overlay]');
    var open    = q('[data-menu-open]');
    var close   = q('[data-menu-close]');

    if (overlay && open) {
      var setOpen = function (on) {
        overlay.classList.toggle('open', on);
        document.body.classList.toggle('menu-open', on);
        open.setAttribute('aria-expanded', on ? 'true' : 'false');
      };
      open.addEventListener('click', function () { setOpen(!overlay.classList.contains('open')); });
      if (close) close.addEventListener('click', function () { setOpen(false); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && overlay.classList.contains('open')) setOpen(false);
      });
    }

    /* Groupes dépliants du menu */
    qa('.menu-group-head').forEach(function (head) {
      head.addEventListener('click', function () {
        var g = head.closest('.menu-group');
        var was = g.classList.contains('open');
        qa('.menu-group.open').forEach(function (o) { if (o !== g) o.classList.remove('open'); });
        g.classList.toggle('open', !was);
        head.setAttribute('aria-expanded', !was ? 'true' : 'false');
      });
    });

    /* Méga-menus de l'en-tête */
    qa('[data-about-toggle]').forEach(function (btn) {
      var host = btn.closest('.hm-about');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var was = host.classList.contains('open');
        qa('.hm-about.open').forEach(function (o) {
          if (o !== host) { o.classList.remove('open'); var b = q('[data-about-toggle]', o); if (b) b.setAttribute('aria-expanded', 'false'); }
        });
        host.classList.toggle('open', !was);
        btn.setAttribute('aria-expanded', !was ? 'true' : 'false');
      });
      host.addEventListener('mouseenter', function () {
        if (window.innerWidth < 1080) return;
        qa('.hm-about.open').forEach(function (o) { if (o !== host) o.classList.remove('open'); });
        host.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      });
      host.addEventListener('mouseleave', function () {
        if (window.innerWidth < 1080) return;
        host.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('click', function () {
      qa('.hm-about.open').forEach(function (o) {
        o.classList.remove('open');
        var b = q('[data-about-toggle]', o); if (b) b.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- 3. ACCORDÉONS ------------------------------ */
  function setAccHeight(acc, on) {
    var body = q('.acc-body', acc);
    if (!body) return;
    body.style.maxHeight = on ? (body.scrollHeight + 'px') : '0px';
  }

  function initAccordions() {
    qa('.acc').forEach(function (acc) {
      var head = q('.acc-head', acc);
      if (!head || head.pcAcc) return;
      head.pcAcc = 1;
      var pm = q('.pm', head);
      if (pm && !pm.textContent.trim()) pm.textContent = '+';
      head.setAttribute('aria-expanded', acc.classList.contains('open') ? 'true' : 'false');
      if (acc.classList.contains('open')) setAccHeight(acc, true);

      head.addEventListener('click', function () {
        var group = acc.parentElement;
        var was = acc.classList.contains('open');
        /* un seul ouvert par groupe */
        qa('.acc.open', group).forEach(function (o) {
          if (o !== acc) {
            o.classList.remove('open');
            setAccHeight(o, false);
            var h = q('.acc-head', o); if (h) h.setAttribute('aria-expanded', 'false');
          }
        });
        acc.classList.toggle('open', !was);
        setAccHeight(acc, !was);
        head.setAttribute('aria-expanded', !was ? 'true' : 'false');
      });
    });

    window.addEventListener('resize', function () {
      qa('.acc.open').forEach(function (a) { setAccHeight(a, true); });
    });
  }

  /* ---------- 4. HERO ------------------------------------ */
  function initHeroSlider() {
    var hero = q('.hero-banner');
    if (!hero) return;
    var slides = qa('.hero-slide', hero);
    var dots   = qa('.hero-dots button', hero);
    if (slides.length < 2) return;

    var idx = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('active'); }));
    var timer = null;

    var go = function (n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('active', i === idx); });
      dots.forEach(function (d, i) {
        d.classList.toggle('active', i === idx);
        d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    };
    var play = function () {
      if (REDUCED) return;
      stop();
      timer = setInterval(function () { go(idx + 1); }, 5000);
    };
    var stop = function () { if (timer) { clearInterval(timer); timer = null; } };

    dots.forEach(function (d, i) {
      d.setAttribute('role', 'tab');
      d.addEventListener('click', function () { go(i); play(); });
    });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', play);

    /* Glissé tactile */
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 44) go(idx + (dx < 0 ? 1 : -1));
      x0 = null; play();
    }, { passive: true });

    go(idx);
    play();
  }

  /* ---------- 5. MARQUEES -------------------------------- */
  function initMarquees() {
    qa('.marquee-track').forEach(function (track) {
      if (track.dataset.pcDup) return;
      var html = track.innerHTML;
      if (!html.trim()) return;
      track.dataset.pcDup = '1';
      /* on répète jusqu'à couvrir 2× la fenêtre, puis on double pour -50% */
      var guard = 0;
      while (track.scrollWidth < window.innerWidth * 2 && guard < 6) {
        track.innerHTML += html; guard++;
      }
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* ---------- 6. TIROIR PANIER (Shopify) ----------------- */
  /* Les routes et le format monétaire viennent de
     window.PC_SETTINGS, posé par layout/theme.liquid. */
  var S = window.PC_SETTINGS || {};
  var ROUTES = S.routes || { cartAdd: '/cart/add.js', cart: '/cart.js', cartChange: '/cart/change.js' };

  /* Le tiroir est écrit en innerHTML : tout texte venu du panier
     passe par ici avant d'être inséré. */
  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function fmt(cents) {
    var f = S.moneyFormat || '{{amount_with_comma_separator}} €';
    var amount = (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    /* Shopify expose plusieurs jetons ; on remplace celui qui est présent. */
    return f.replace(/\{\{\s*amount(_with_comma_separator|_no_decimals|_with_apostrophe_separator|_no_decimals_with_comma_separator)?\s*\}\}/, amount);
  }

  function openCart(on) {
    var d = q('[data-cart-drawer]'), s = q('[data-cart-scrim]');
    if (d) d.classList.toggle('open', on);
    if (s) s.classList.toggle('open', on);
    document.body.classList.toggle('menu-open', on);
  }

  function renderCart(cart) {
    qa('[data-cart-count]').forEach(function (c) {
      c.textContent = cart.item_count;
      c.style.display = cart.item_count ? '' : 'none';
    });

    var box = q('[data-cart-items]');
    if (box) {
      if (!cart.items.length) {
        box.innerHTML = '<p class="cart-empty">Votre panier est vide.<br>Il attend votre premier rituel.</p>';
      } else {
        box.innerHTML = cart.items.map(function (i) {
          var img = i.image
            ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="" width="62" height="62">'
            : '';
          var opts = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title + ' · ' : '';
          /* Propriétés de ligne : le panneau de contenance y dépose le
             choix de la cliente. Sans cet affichage, elle ne pourrait
             pas vérifier dans le panier ce qu'elle a sélectionné.
             Shopify réserve les clés commençant par « _ » à l'usage
             interne : on ne les montre pas. */
          var props = '';
          if (i.properties) {
            Object.keys(i.properties).forEach(function (k) {
              var val = i.properties[k];
              if (k.charAt(0) === '_' || !val) return;
              props += '<span class="cart-line-opt">' + esc(k) + ' : ' + esc(val) + '</span>';
            });
          }
          return '<div class="cart-line" data-key="' + i.key + '">' +
            '<span class="cart-line-img">' + img + '</span>' +
            '<span class="cart-line-b"><b>' + i.product_title + '</b>' +
              '<span>' + opts + 'Qté ' + i.quantity + '</span>' + props +
              '<button type="button" class="cart-line-rm" data-remove="' + i.key + '">Retirer</button>' +
            '</span>' +
            '<span class="cart-line-p">' + fmt(i.final_line_price) + '</span>' +
          '</div>';
        }).join('');
      }
    }

    var sum = q('[data-cart-sum]');
    if (sum) sum.textContent = fmt(cart.total_price);

    var ship = q('[data-cart-ship]');
    if (ship && S.freeShipThreshold > 0) {
      ship.textContent = cart.total_price >= S.freeShipThreshold
        ? 'Livraison offerte — seuil atteint.'
        : 'Plus que ' + fmt(S.freeShipThreshold - cart.total_price) + ' pour la livraison offerte.';
    }
  }

  function refreshCart(then) {
    return fetch(ROUTES.cart, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (then) then(cart); return cart; })
      .catch(function () { /* hors ligne : on laisse l'affichage en place */ });
  }

  /* Choix du panneau de contenance, sous forme de propriétés de ligne.
     Seul le panneau de l'offre sélectionnée est visible : les autres
     portent l'attribut `hidden`. Renvoie null si rien à transmettre,
     pour ne pas poser `properties:{}` sur l'article. */
  function swatchChoices() {
    var out = null;
    qa('.cb-pane:not([hidden]) [data-swatch-group]').forEach(function (group) {
      var key = group.getAttribute('data-swatch-group');
      var on  = q('.swatch.active', group);
      if (!key || !on) return;
      out = out || {};
      out[key] = on.getAttribute('data-swatch-value') || '';
    });
    return out;
  }

  function addToCart(items, btn) {
    var label = btn && q('.add-label', btn);
    var old = label && label.textContent;
    if (btn) btn.disabled = true;
    if (label) label.textContent = 'Ajout…';

    return fetch(ROUTES.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Ajout impossible');
        return refreshCart(function () { openCart(true); });
      })
      .catch(function (err) {
        if (label) label.textContent = err.message.slice(0, 60);
        setTimeout(function () { if (label) label.textContent = old; }, 2600);
      })
      .then(function () {
        if (btn) btn.disabled = false;
        if (label && label.textContent === 'Ajout…') label.textContent = old;
      });
  }

  function initCart() {
    var btn = q('.cart-btn');
    if (btn && S.cartDrawer !== false) {
      btn.addEventListener('click', function (e) { e.preventDefault(); openCart(true); });
    }
    var close = q('[data-cart-close]');
    if (close) close.addEventListener('click', function () { openCart(false); });
    var scrim = q('[data-cart-scrim]');
    if (scrim) scrim.addEventListener('click', function () { openCart(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openCart(false); });

    /* Ajout au panier — un seul écouteur pour les trois boutons */
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-add], [data-add-pack], [data-sticky-add]') : null;
      if (!t) return;

      var items = [];
      var props = swatchChoices();

      if (t.hasAttribute('data-add-pack')) {
        /* Pack : le produit courant + le produit associé */
        var main = q('[data-variant-input]');
        if (main && main.value) {
          var line = { id: +main.value, quantity: 1 };
          if (props) line.properties = props;
          items.push(line);
        }
        if (t.dataset.variantId) items.push({ id: +t.dataset.variantId, quantity: 1 });
      } else {
        /* Offre sélectionnée, sinon la variante du formulaire */
        var sel = q('.offer.sel');
        var vid = (sel && sel.dataset.variantId) || t.dataset.variantId;
        if (!vid) {
          var input = q('[data-variant-input]');
          vid = input && input.value;
        }
        var qtyEl = q('.qty input');
        var qty = Math.max(1, parseInt((qtyEl && qtyEl.value) || '1', 10));
        if (sel && sel.dataset.qty) qty = qty * Math.max(1, parseInt(sel.dataset.qty, 10));
        if (vid) {
          var one = { id: +vid, quantity: qty };
          if (props) one.properties = props;
          items.push(one);
        }
      }

      if (!items.length) return;   /* pas de variante : on laisse le formulaire agir */
      e.preventDefault();
      addToCart(items, t);
    });

    /* Retrait d'une ligne */
    document.addEventListener('click', function (e) {
      var rm = e.target.closest ? e.target.closest('[data-remove]') : null;
      if (!rm) return;
      e.preventDefault();
      fetch(ROUTES.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: rm.dataset.remove, quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(renderCart);
    });

    refreshCart();
  }

  /* ---------- 7. GALERIE PRODUIT ------------------------- */
  /* Slide classique, sans flèches : les visuels sont rangés dans une
     piste à défilement horizontal aimanté (scroll-snap), qu'on fait
     glisser au doigt, au trackpad ou à la souris. Trois repères disent
     qu'il y a d'autres photos : les pointillés, le compteur « 1 / 13 »
     en haut à droite, et un léger aperçu du visuel suivant la première
     fois que la galerie entre à l'écran. */
  function initGallery() {
    var main = q('[data-gallery-main]');
    if (!main) return;
    var slides = qa('.g-slide', main);
    var dots = qa('[data-gal-dot]', main);
    if (!slides.length) return;

    /* Les flèches restent dans le gabarit : on les retire ici. */
    qa('.gal-arrow', main).forEach(function (a) { a.remove(); });

    var track = document.createElement('div');
    track.className = 'g-track';
    main.insertBefore(track, slides[0]);
    slides.forEach(function (s) { s.classList.remove('active'); track.appendChild(s); });
    if (slides.length < 2) return;

    track.tabIndex = 0;
    track.setAttribute('role', 'region');
    track.setAttribute('aria-label', 'Visuels du produit — glisser pour voir les suivants');

    var count = document.createElement('span');
    count.className = 'gal-count';
    count.setAttribute('aria-hidden', 'true');
    main.appendChild(count);

    var i = -1;
    var mark = function (n) {
      if (n === i) return;
      i = n;
      dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
      count.textContent = (i + 1) + ' / ' + slides.length;
    };
    var go = function (n, instant) {
      n = Math.max(0, Math.min(slides.length - 1, n));
      track.scrollTo({ left: n * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      mark(n);
    };
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });

    var raf = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
      });
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
    });

    /* Souris : glisser-déposer. Le tactile et le trackpad passent par
       le défilement natif, rien à faire pour eux. */
    var drag = null;
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { x: e.clientX, left: track.scrollLeft, from: i };
      track.classList.add('is-dragging');
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', function (e) {
      if (drag) track.scrollLeft = drag.left - (e.clientX - drag.x);
    });
    var drop = function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x, from = drag.from;
      drag = null;
      track.classList.remove('is-dragging');
      go(Math.abs(dx) > 44 ? from + (dx < 0 ? 1 : -1) : from);
    };
    track.addEventListener('pointerup', drop);
    track.addEventListener('pointercancel', drop);

    window.addEventListener('resize', function () { go(i, true); });

    /* Aperçu : la piste glisse de 14 % puis revient, une seule fois,
       pour montrer qu'il y a une photo à droite. Annulé si le visiteur
       a déjà fait défiler, et sans animation si le système le demande. */
    if (!REDUCED && window.IntersectionObserver) {
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        io.disconnect();
        setTimeout(function () {
          if (track.scrollLeft > 2 || drag) return;
          track.classList.add('is-nudging');
          track.scrollTo({ left: Math.round(track.clientWidth * 0.14), behavior: 'smooth' });
          setTimeout(function () {
            track.scrollTo({ left: 0, behavior: 'smooth' });
            setTimeout(function () { track.classList.remove('is-nudging'); }, 500);
          }, 550);
        }, 700);
      }, { threshold: 0.6 });
      io.observe(track);
    }

    mark(0);
  }

  /* ---------- 8. CARROUSEL D'AVIS (buybox) --------------- */
  function initBbReviews() {
    var host = q('[data-bb-reviews]');
    if (!host) return;
    var track = q('.bbr-track', host);
    var items = qa('.bbr-item', host);
    if (!track || items.length < 2) return;

    var dots = document.createElement('div');
    dots.className = 'bbr-dots';
    items.forEach(function (_, k) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'bbr-dot' + (k === 0 ? ' active' : '');
      d.setAttribute('aria-label', 'Avis ' + (k + 1));
      dots.appendChild(d);
    });
    host.appendChild(dots);

    var i = 0, timer = null;
    var go = function (n) {
      i = (n + items.length) % items.length;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      qa('.bbr-dot', dots).forEach(function (d, k) { d.classList.toggle('active', k === i); });
    };
    var play = function () { if (REDUCED) return; stop(); timer = setInterval(function () { go(i + 1); }, 5200); };
    var stop = function () { if (timer) { clearInterval(timer); timer = null; } };

    qa('.bbr-dot', dots).forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
    var p = q('.bbr-prev', host), n = q('.bbr-next', host);
    if (p) p.addEventListener('click', function () { go(i - 1); play(); });
    if (n) n.addEventListener('click', function () { go(i + 1); play(); });
    host.addEventListener('mouseenter', stop);
    host.addEventListener('mouseleave', play);
    go(0); play();
  }

  /* ---------- 9. OFFRES + CONTENANCES -------------------- */
  function initOffers() {
    var host = q('[data-offers]');
    if (!host) return;
    var offers = qa('.offer', host);
    if (!offers.length) return;

    var apply = function (offer) {
      offers.forEach(function (o) {
        var on = o === offer;
        o.classList.toggle('sel', on);
        var r = q('input', o); if (r) r.checked = on;
      });
      /* panneau de contenances correspondant */
      var pane = offer.dataset.offer;
      qa('[data-pane]').forEach(function (p) { p.hidden = p.dataset.pane !== pane; });

      /* CTA + barre flottante */
      var price = parseInt(offer.dataset.price || '0', 10);
      var was   = parseInt(offer.dataset.was   || '0', 10);
      var add   = q('[data-add]');
      if (add) {
        add.dataset.price = price;
        add.dataset.variant = offer.dataset.label || '';
        var lbl = q('.add-label', add);
        /* Le libellé appartient au bloc « Bouton d'achat » : le réécrire en
           dur effaçait le texte choisi dans la barre latérale au premier
           clic sur un palier — et ressuscitait « Ajouter au panier » sur un
           bouton rebaptisé. On repart de data-label-base, et le prix ne
           s'ajoute que si le réglage le demande. Bouton épuisé : on n'y
           touche pas, « Épuisé » reste. */
        if (lbl && !add.disabled) {
          var base = add.dataset.labelBase || lbl.textContent;
          lbl.textContent = add.dataset.showPrice === '0' ? base : base + ' — ' + money(price);
        }
      }

      /* La variante du formulaire suit le palier. Sans ça, le paiement
         accéléré (Shop Pay, Apple Pay) part sur la variante par défaut,
         quel que soit le lot choisi juste au-dessus. */
      var vinput = q('[data-variant-input]');
      if (vinput && offer.dataset.variantId) vinput.value = offer.dataset.variantId;

      /* Cadeaux : s'allume tout ce que ce palier débloque, s'éteint le
         reste — la cliente voit ce qu'elle gagnerait un cran plus haut. */
      var rank = parseInt(offer.dataset.rank || '1', 10);
      qa('[data-gift]').forEach(function (g) {
        g.classList.toggle('is-on', parseInt(g.dataset.from || '1', 10) <= rank);
      });
      var sp = q('[data-sticky-price]');
      if (sp) sp.textContent = money(price);
      var sw = q('[data-sticky-was]');
      if (sw) { sw.textContent = was ? money(was) : ''; sw.style.display = was ? '' : 'none'; }
      var sa = q('[data-sticky-add]');
      if (sa) { sa.dataset.price = price; sa.dataset.variant = offer.dataset.label || ''; }
    };

    offers.forEach(function (o) {
      o.addEventListener('click', function () { apply(o); });
      o.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); apply(o); }
      });
    });
    apply(offers.filter(function (o) { return o.classList.contains('sel'); })[0] || offers[0]);

    /* Choix de contenance / teinte */
    qa('[data-swatch-group]').forEach(function (group) {
      qa('.swatch', group).forEach(function (sw) {
        sw.addEventListener('click', function () {
          qa('.swatch', group).forEach(function (s) { s.classList.remove('active'); });
          sw.classList.add('active');
          var out = q('.cb-out', group.closest('.cb-unit') || group);
          if (out) out.textContent = sw.dataset.swatchValue || '';
        });
      });
    });
  }

  /* ---------- 9 bis. BANDEAU DE PROMESSES ---------------- */
  /* La piste est écrite une seule fois en Liquid. Ici on la répète
     jusqu'à couvrir deux fois la colonne, puis on double le tout :
     la translation de -50 % retombe alors pile sur une copie, et la
     boucle est sans couture. Les copies sont masquées aux lecteurs
     d'écran — qui liraient sinon les mêmes promesses six fois — et
     dépouillées de leurs attributs d'éditeur, sans quoi le
     personnalisateur surlignerait toutes les copies d'un bloc. */
  function initPromises() {
    qa('[data-promises]').forEach(function (box) {
      var track = q('[data-promises-track]', box);
      if (!track || track.dataset.pcDup) return;
      var items = qa('.bb-pro', track);
      if (!items.length) return;
      track.dataset.pcDup = '1';

      /* Liste courte, qui tient dans la colonne : on la pose au centre
         et on n'anime rien — un défilement sans débordement n'est que
         du mouvement pour du mouvement. */
      if (track.scrollWidth <= box.clientWidth) { box.classList.add('is-still'); return; }

      var copy = function () {
        items.forEach(function (it) {
          var c = it.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          qa('*', c).concat([c]).forEach(function (n) {
            Array.prototype.slice.call(n.attributes || []).forEach(function (a) {
              if (a.name.indexOf('data-shopify') === 0) n.removeAttribute(a.name);
            });
          });
          track.appendChild(c);
        });
      };

      var guard = 0;
      while (track.scrollWidth < box.clientWidth * 2 && guard < 8) { copy(); guard++; }
      var half = track.scrollWidth;
      var full = qa('.bb-pro', track).length;
      for (var k = 0; k < full; k++) {
        var c = track.children[k].cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        track.appendChild(c);
      }
      /* Vitesse constante — 32 px par seconde — plutôt qu'une durée fixe :
         une bande de quatre promesses et une bande de huit défilent au
         même rythme, assez lentement pour qu'on lise chaque libellé au
         passage. */
      box.style.setProperty('--bb-pro-dur', Math.max(22, Math.round(half / 32)) + 's');
      box.classList.add('is-marquee');
    });
  }

  /* ---------- 9 ter. COMPTE À REBOURS + DATE DE LIVRAISON  */
  var pad2 = function (n) { return n < 10 ? '0' + n : '' + n; };

  /* Le compte à rebours est ancré sur l'horloge : ce qui reste avant la
     fin du cycle en cours, jamais une durée repartie de zéro. Deux
     onglets affichent la même chose, et revenir une heure plus tard
     montre bien une heure de moins. */
  var CD_TIMER = null;
  function initCountdown() {
    var els = qa('[data-countdown]');
    if (CD_TIMER) { clearInterval(CD_TIMER); CD_TIMER = null; }
    if (!els.length) return;
    var tick = function () {
      var now = Math.floor(Date.now() / 1000);
      els.forEach(function (el) {
        var cyc = (parseInt(el.dataset.hours || '8', 10) || 8) * 3600;
        var left = cyc - (now % cyc);
        var parts = qa('span', el);
        var v = [pad2(Math.floor(left / 3600)), pad2(Math.floor(left / 60) % 60), pad2(left % 60)];
        if (parts.length >= 3) parts.forEach(function (s, i) { if (v[i]) s.textContent = v[i]; });
        else el.textContent = v.join(':');
      });
    };
    tick();
    CD_TIMER = setInterval(tick, 1000);
  }

  /* La date de livraison se compte en jours OUVRÉS, samedi et dimanche
     sautés. Liquid l'a déjà écrite, mais avec l'heure du rendu : une
     page servie depuis le cache de Shopify afficherait la date d'hier.
     Le navigateur, lui, connaît le jour de la visite. */
  function initDeliveryDate() {
    qa('[data-delivery-date]').forEach(function (el) {
      var days = parseInt(el.dataset.days || '4', 10) || 4;
      var d = new Date(), guard = 0;
      while (days > 0 && guard < 40) {
        d.setDate(d.getDate() + 1); guard++;
        var w = d.getDay();
        if (w !== 0 && w !== 6) days--;
      }
      el.textContent = pad2(d.getDate()) + '/' + pad2(d.getMonth() + 1) + '/' + d.getFullYear();
    });
  }

  /* ---------- 10. QUANTITÉ ------------------------------- */
  function initQty() {
    var box = q('.qty');
    if (!box) return;
    var input = q('input', box);
    var dec = q('[data-dec]', box), inc = q('[data-inc]', box);
    var set = function (v) { input.value = Math.min(20, Math.max(1, v)); };
    if (dec) dec.addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
    if (inc) inc.addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
    input.addEventListener('change', function () { set(parseInt(input.value, 10) || 1); });
  }

  /* ---------- 11. BARRE D'ACHAT FLOTTANTE ---------------- */
  function initStickyBuy() {
    var bar = q('[data-sticky-buy]');
    /* On guette le bouton « Ajouter au panier » de la buybox, pas la
       buybox entière : la barre arrive dès qu'on l'a dépassé, sans
       doubler un bouton encore visible. Repli sur la buybox si le bloc
       bouton a été retiré. */
    var anchor = q('[data-buy-anchor] [data-add]') || q('[data-buy-anchor]');
    if (!bar || !anchor) return;
    var show = function (v) { bar.classList.toggle('show', v); };

    /* IntersectionObserver plutôt qu'un getBoundingClientRect par
       événement scroll : l'observateur livre `boundingClientRect` sans
       que le thread principal lise le layout, et ne se réveille qu'au
       franchissement du seuil. L'ancienne lecture tombait juste après
       les écritures de pc-storybook.js sur :root — donc recalcul de
       style de tout l'arbre, garanti, à chaque frame de scroll. */
    if (!window.IntersectionObserver) {
      var tick = function () { show(anchor.getBoundingClientRect().bottom < 40); };
      window.addEventListener('scroll', tick, { passive: true });
      window.addEventListener('resize', tick);
      tick();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { show(e.boundingClientRect.bottom < 40); });
    }, { rootMargin: '-40px 0px 0px 0px', threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- 12. BARRES DE NOTATION --------------------- */
  function initRatingBars() {
    qa('.rating-bar').forEach(function (row) {
      var fill = q('.fill', row);
      if (!fill) return;
      var pct = row.dataset.pct || '0';
      if (!window.IntersectionObserver) { fill.style.setProperty('--w', pct + '%'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          fill.style.transition = 'width 1s cubic-bezier(.22,.7,.3,1)';
          fill.style.setProperty('--w', pct + '%');
          io.unobserve(e.target);
        });
      }, { threshold: 0.4 });
      io.observe(row);
    });
  }

  /* ---------- BOOT --------------------------------------- */
  function boot() {
    initReveal();
    initMenu();
    initAccordions();
    initHeroSlider();
    initMarquees();
    initCart();
    initGallery();
    initBbReviews();
    initOffers();
    initPromises();
    initCountdown();
    initDeliveryDate();
    initQty();
    initStickyBuy();
    initRatingBars();

    /* Formulaires de démo en aperçu */
    qa('form[data-fake]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = q('button', f);
        if (btn) { var old = btn.textContent; btn.textContent = 'Merci !'; setTimeout(function () { btn.textContent = old; }, 2200); }
        f.reset();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Personnalisateur de thème : la section revient neuve à chaque
     réglage. Les trois blocs ajoutés à la fiche produit se rebranchent,
     sinon le bandeau cesse de défiler et le compte à rebours se fige
     dès qu'on touche à un réglage. */
  document.addEventListener('shopify:section:load', function () {
    initPromises(); initCountdown(); initDeliveryDate(); initOffers();
  });
})();

/* ============================================================
   Avant / Après (section pc-before-after)
   Le curseur est un <input type="range"> posé sur l'image : le glissé
   tactile, la souris et les flèches du clavier sont gérés par le
   navigateur. On ne fait que répercuter la valeur sur la découpe.
   ============================================================ */
(function () {
  'use strict';

  function poser(panel, pct) {
    var poigne = panel.querySelector('[data-ba-handle]');
    panel.style.setProperty('--ba-pos', pct + '%');
    if (poigne) poigne.style.left = pct + '%';
  }

  function brancher(racine) {
    var panneaux = racine.querySelectorAll('[data-ba-panel]');

    panneaux.forEach(function (panel) {
      var curseur = panel.querySelector('[data-ba-range]');
      if (!curseur) return;
      poser(panel, curseur.value);
      curseur.addEventListener('input', function () { poser(panel, curseur.value); });
    });

    var onglets = racine.querySelectorAll('[data-ba-tab]');
    onglets.forEach(function (onglet) {
      onglet.addEventListener('click', function () {
        var i = onglet.getAttribute('data-ba-tab');

        onglets.forEach(function (o) {
          var actif = o === onglet;
          o.classList.toggle('is-on', actif);
          o.setAttribute('aria-selected', actif ? 'true' : 'false');
        });

        panneaux.forEach(function (p) {
          p.classList.toggle('is-on', p.getAttribute('data-ba-panel') === i);
        });
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ba]').forEach(brancher);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  // Personnalisateur de thème : la section est rechargée à chaud
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
